import src from "IMAGE";
export default { src, width: 230, height: 26, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AMEXHq+OGC6dWxxQrDIYWJspFU6EKhZQgy8ZWpYwGFaUsYYKVDxdwIoAAAAASUVORK5CYII=", blurWidth: 8, blurHeight: 1 }
